import { createSelector } from 'reselect'
import hasUnlockedSecondTierTrackerCartSelect from 'modules/cart/redux/selectors/has-unlocked-second-tier-tracker'
import hasUnlockedLastTierTrackerCartSelect from 'modules/cart/redux/selectors/has-unlocked-last-tier-tracker'
import isCheckoutMinimumFlowCartUtil from 'modules/gift/utils/is-checkout-minimum-flow-type'
import getFiltersProductSelect from 'modules/product/redux/selectors/get-filters'
import isNewCustomerSelect from 'modules/customer/redux/selectors/is-new-customer'
import getUrlExpressCheckoutSelectUtil from 'containers/CartBottomBar/components/ExpressCheckoutButton/selectors/get-url/utils'
import isSelectFreeBonusDeluxeSamplesStepGiftSelect from 'modules/gift/redux/selectors/is-select-bonus-deluxe-samples-step'
import getPermalinkExpressCheckoutSelect from 'containers/CartBottomBar/components/ExpressCheckoutButton/selectors/get-permalink'

const getUrlExpressCheckoutSelect = createSelector(
  getFiltersProductSelect,
  hasUnlockedSecondTierTrackerCartSelect,
  hasUnlockedLastTierTrackerCartSelect,
  isNewCustomerSelect,
  isSelectFreeBonusDeluxeSamplesStepGiftSelect,
  getPermalinkExpressCheckoutSelect,
  (
    filters,
    hasUnlockedSecondTierTracker,
    hasUnlockedLastTierTracker,
    isNewCustomerSelect,
    isSelectFreeBonusDeluxeSamplesStep,
    expressCheckoutPermalink
  ) => {
    return getUrlExpressCheckoutSelectUtil({
      filters,
      hasUnlockedSecondTierTracker,
      hasUnlockedLastTierTracker,
      isCheckoutMinimumFlow: isCheckoutMinimumFlowCartUtil(),
      isNewCustomerSelect,
      isSelectFreeBonusDeluxeSamplesStep,
      expressCheckoutPermalink
    })
  }
)

export default getUrlExpressCheckoutSelect
